export default "__VITE_ASSET__Bl95NLwA__"